/* GoodyBro hero slideshow with optional background video per slide. */
(function () {
  'use strict';
  if (customElements.get('gb-hero-slideshow')) return;

  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const isVisible = (el) => el.getClientRects().length > 0;

  class GBHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = $$('[data-slide]', this);
      this.counter = this.querySelector('[data-counter]');
      this.dots = $$('[data-dot]', this);
      this.index = 0;
      this.paused = false;
      this.inView = true;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = parseInt(this.dataset.autoplay, 10) || 0;
      this.speed = speed;
      this.auto = speed > 0 && !this.reduced && this.slides.length > 1;

      this.setupVideos();

      if (!this.track || this.slides.length < 2) {
        this.playActive();
        return;
      }

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._s);
        this._s = setTimeout(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) this.setIndex(i);
        }, 60);
      }, { passive: true });

      if (this.auto) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('touchstart', () => this.stop(), { passive: true });
      }

      this._onBlockSelect = (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target));
        if (i > -1) { this.stop(); this.go(i); }
      };
      document.addEventListener('shopify:block:select', this._onBlockSelect);

      this.setIndex(0);
    }

    disconnectedCallback() {
      clearTimeout(this._a);
      if (this._io) this._io.disconnect();
      if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    setupVideos() {
      this.videos = $$('[data-hero-video]', this);
      if (!this.videos.length) return;

      this.videos.forEach((v) => {
        v.muted = true;
        v.addEventListener('playing', () => v.classList.add('is-playing'));
        v.addEventListener('ended', () => {
          if (v !== this.activeVideo()) return;
          if (this.auto && !this.paused) {
            this.go(this.index + 1);
          } else {
            v.currentTime = 0;
            v.play().catch(() => {});
          }
        });
      });

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(([en]) => {
          this.inView = en.isIntersecting;
          this.playActive();
        }, { threshold: 0.25 });
        this._io.observe(this);
      }

      this._onResize = () => {
        clearTimeout(this._r);
        this._r = setTimeout(() => this.playActive(), 200);
      };
      window.addEventListener('resize', this._onResize);
    }

    activeVideo() {
      const slide = this.slides[this.index];
      if (!slide) return null;
      return $$('[data-hero-video]', slide).find(isVisible) || null;
    }

    playActive() {
      if (!this.videos || !this.videos.length) return;
      const active = this.inView && !this.reduced ? this.activeVideo() : null;
      this.videos.forEach((v) => {
        if (v === active) {
          if (v.preload !== 'auto') v.preload = 'auto';
          const p = v.play();
          if (p && p.catch) p.catch(() => { v._failed = true; this.schedule(); });
        } else if (!v.paused) {
          v.pause();
          if (v.dataset.wait === 'true') v.currentTime = 0;
        }
      });
    }

    schedule() {
      clearTimeout(this._a);
      if (!this.auto || this.paused) return;
      const v = this.activeVideo();
      if (v && v.dataset.wait === 'true' && this.inView && !v._failed) return;
      this._a = setTimeout(() => this.go(this.index + 1), this.speed * 1000);
    }

    stop() {
      this.paused = true;
      clearTimeout(this._a);
    }

    resume() {
      this.paused = false;
      this.schedule();
    }

    go(i) {
      const n = this.slides.length;
      i = (i + n) % n;
      this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
      this.setIndex(i);
    }

    setIndex(i) {
      this.index = i;
      const n = this.slides.length;
      if (this.counter) this.counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      this.slides.forEach((s, k) => s.setAttribute('aria-hidden', k === i ? 'false' : 'true'));
      this.playActive();
      this.schedule();
    }
  }

  customElements.define('gb-hero-slideshow', GBHeroSlideshow);
})();
